import {Tooltip} from 'flowbite';

export default (targetId, triggerId, placement, component) => {
  const $targetEl = document.getElementById(targetId);
  const $triggerEl = document.getElementById(triggerId);

  if (!$targetEl || !$triggerEl) {
    return {
      init() {
      },
      show() {
      },
      hide() {
      },
      toggle() {
      },
      destroy() {
      },
    };
  }

  const options = {
    placement: placement,
    triggerType: 'hover',
    onShow: async () => {
      $targetEl.classList.remove('hidden');
      await component.invokeMethodAsync('Show');
    },
    onHide: async () => {
      await component.invokeMethodAsync('Hide');
    }
  };

  return new Tooltip($targetEl, $triggerEl, options);
};
